/**
 * TrialBanner - bandeau persistant en haut quand on est en mode trial.
 * Discret mais toujours visible. CTA -> /license pour activer.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Badge20Regular, LockClosed20Regular } from '@fluentui/react-icons';
import { tokens } from '@fluentui/react-components';
import { useLicense } from '../auth/LicenseGate';

export function TrialBanner() {
  const { isTrial, loading, status } = useLicense();
  const { t } = useTranslation();

  if (loading || !isTrial) return null;

  const expired = Boolean(status?.expired);

  return (
    <div
      role="status"
      style={{
        background: expired
          ? 'linear-gradient(90deg, #FBE7E7 0%, #FFF3D6 100%)'
          : 'linear-gradient(90deg, #FFF3D6 0%, #E8F5F6 100%)',
        borderBottom: `2px solid ${expired ? '#C13C3C' : '#D88A00'}`,
        padding: '10px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 14,
        fontSize: 13,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {expired
          ? <LockClosed20Regular primaryFill="#C13C3C" />
          : <Badge20Regular primaryFill="#D88A00" />}
        <div>
          <strong style={{ color: expired ? '#8A1E1E' : '#8A6308' }}>
            {expired ? t('trialBanner.expired') : t('trialBanner.active')}
          </strong>
          <span style={{ marginLeft: 8, color: tokens.colorNeutralForeground3 }}>
            {expired ? t('trialBanner.expiredDescription') : t('trialBanner.description')}
          </span>
        </div>
      </div>
      <Link
        to="/license"
        style={{
          display: 'inline-block',
          padding: '6px 14px',
          background: tokens.colorBrandBackground,
          color: '#fff',
          borderRadius: 6,
          fontWeight: 600,
          fontSize: 12,
          textDecoration: 'none',
        }}
      >
        {expired ? t('trialBanner.expiredCta') : t('trialBanner.cta')}
      </Link>
    </div>
  );
}
